import { useReducedMotion } from 'framer-motion';

import { type LeadershipMember } from '../leadership-data';

import { LeadershipCard } from './leadership-card';

/**
 * Scroll-driven leadership stack:
 * Renders cards positioned directly below one another with standard spacing.
 * As the user scrolls down, each card reaches the sticky top and smoothly
 * slides over the card pinned above it. Scrolling up reverses the motion natively.
 * Fully supports prefers-reduced-motion fallback matching website standards.
 */
export function LeadershipScrollStory({
  members,
  onOpen,
}: {
  members: LeadershipMember[];
  onOpen: (member: LeadershipMember) => void;
}) {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <div className="mx-auto max-w-5xl space-y-6 pb-12">
        {members.map((member) => (
          <LeadershipCard key={member.id} member={member} onOpen={onOpen} />
        ))}
      </div>
    );
  }

  return (
    <div className="relative mx-auto max-w-5xl space-y-8 pb-16 lg:space-y-12">
      {members.map((member, index) => (
        <div
          key={member.id}
          style={{ zIndex: index + 1 }}
          className="sticky top-20 lg:top-24"
        >
          <LeadershipCard member={member} onOpen={onOpen} />
        </div>
      ))}
    </div>
  );
}




